import { ChevronLeft } from "lucide-react";
import type { ReactNode } from "react";
import { cn } from "@/lib/cn";
import { chooseLocalizedText } from "@/lib/localizedText";
import { useLanguageStore } from "@/stores/languageStore";

interface AppHeaderProps {
  title: string;
  onBack?: () => void;
  rightAction?: ReactNode;
  className?: string;
}

export function AppHeader({ title, onBack, rightAction, className }: AppHeaderProps) {
  const language = useLanguageStore((state) => state.language);

  return (
    <header
      className={cn(
        "sticky top-0 z-30 flex h-12 items-center justify-between",
        "bg-[var(--color-bg)]/80 px-4 backdrop-blur-md",
        className,
      )}
    >
      <div className="flex min-w-10 items-center">
        {onBack && (
          <button
            type="button"
            onClick={onBack}
            className="flex h-10 w-10 items-center justify-center rounded-full
                       text-[var(--color-text-secondary)] transition-colors
                       active:scale-[0.95] active:bg-[var(--color-surface)]"
            aria-label="Go back"
          >
            <ChevronLeft className="h-5 w-5" />
          </button>
        )}
      </div>

      <h1 className="font-headline text-lg font-bold tracking-tight text-[var(--color-text)]">
        {chooseLocalizedText(title, language)}
      </h1>

      <div className="flex min-w-10 items-center justify-end">{rightAction}</div>
    </header>
  );
}
